import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { ShopLogo } from "@/components/ShopLogo";
import { DemoBadge, PremiumBadge } from "@/components/Badges";

export const ShopCard = ({ s }) => (
  <Link
    to={`/boutique/${s.slug}`}
    data-testid={`shop-card-${s.slug}`}
    className="group flex min-w-[240px] snap-start items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition-transform duration-200 hover:-translate-y-1 hover:shadow-md"
  >
    <ShopLogo shop={s} className="h-14 w-14 rounded-xl text-lg" />
    <div className="min-w-0">
      <div className="flex flex-wrap items-center gap-1">
        {s.premium && <PremiumBadge />}
        {s.demo && <DemoBadge />}
      </div>
      <p className="mt-1 truncate font-display text-base font-bold text-gray-900">{s.name}</p>
      <p className="flex items-center gap-1 text-xs text-gray-500">
        <MapPin className="h-3 w-3" /> {s.city}
        {s.product_count != null && <span className="ml-1">· {s.product_count} produits</span>}
      </p>
    </div>
  </Link>
);
